import { create } from 'zustand'
import { AlertScopeType } from '@magnetar/admin-api-interfaces'

interface DisconnectionAlertDialogState {
  isOpen: boolean
  scopeType: AlertScopeType
  scopeId: number | undefined
  openDialog: (scopeType: AlertScopeType, scopeId?: number) => void
  closeDialog: () => void
}

export const useDisconnectionAlertDialog = create<DisconnectionAlertDialogState>()((set) => ({
  isOpen: false,
  scopeType: AlertScopeType.system,
  scopeId: undefined,
  openDialog: (scopeType: AlertScopeType, scopeId?: number) =>
    set({ isOpen: true, scopeType, scopeId }),
  closeDialog: () => set({ isOpen: false }),
}))
